// Lo que el bot sabe decir · DIRECTRIZ-BOT-INTELIGENTE F5 (16 sep 2026)
//
// La base de conocimiento es LO ÚNICO que el bot público puede decir en
// texto libre: cada fragmento tiene un título, el texto (hechos, sin
// precios: esos salen de la tabla de planes) y las palabras con las que
// se encuentra. Debajo, lo que la gente preguntó y la base no tenía: la
// lista de lo que falta por escribir. Vive dentro de «Interesados» por lo
// mismo que «Cómo saluda el bot»: es donde el dueño mira a su bot.
import { useFormularioTocado, useSubpantalla } from '../ui/navegacionReact';
import { useCallback, useEffect, useState } from 'react';
import { BookOpen, CheckCircle2, Save } from 'lucide-react';
import { apiPanel } from '../panel/api';

const NUEVO = { clave: '', titulo: '', texto: '', palabras: '', activo: true };

export default function ConocimientoDelBot() {
  const [abierto, setAbierto] = useState(false);
  const [fragmentos, setFragmentos] = useState([]);
  const [preguntas, setPreguntas] = useState([]);
  const [editando, setEditando] = useState(null);
  useSubpantalla('editando', !!editando, () => setEditando(null), { reemplaza: true });
  // Con el fragmento a medio escribir, atrás pregunta antes de cerrarlo (TC-DR-AT).
  const [vigilar] = useFormularioTocado({ sub: 'editando' });
  const [error, setError] = useState(null);
  const [guardado, setGuardado] = useState(false);
  const [cargando, setCargando] = useState(false);

  const cargar = useCallback(() => {
    setCargando(true);
    Promise.all([apiPanel.get('/bot/conocimiento'), apiPanel.get('/bot/preguntas')])
      .then(([f, p]) => {
        setFragmentos(f);
        setPreguntas(p);
        setError(null);
      })
      .catch((e) => setError(e.message))
      .finally(() => setCargando(false));
  }, []);

  useEffect(() => {
    if (!abierto) return undefined;
    const t = setTimeout(cargar, 0);
    return () => clearTimeout(t);
  }, [abierto, cargar]);

  const guardar = () => {
    setGuardado(false);
    apiPanel
      .post('/bot/conocimiento', editando)
      .then((f) => {
        setFragmentos(f);
        setEditando(null);
        setGuardado(true);
        setError(null);
      })
      .catch((e) => setError(e.message));
  };

  const atendida = (id) =>
    apiPanel
      .post(`/bot/preguntas/${id}/atendida`)
      .then(setPreguntas)
      .catch((e) => setError(e.message));

  const pendientes = preguntas.filter((p) => !p.atendida_en);
  const puedeGuardar =
    editando && editando.clave.trim() && editando.titulo.trim() && editando.texto.trim();

  return (
    <section className="mt-6 rounded-xl border bg-white">
      <button
        type="button"
        onClick={() => setAbierto((v) => !v)}
        className="w-full flex items-center gap-3 p-4 text-left"
      >
        <BookOpen className="h-5 w-5 text-gray-500 shrink-0" />
        <span className="flex-1">
          <span className="block font-semibold text-gray-900">Lo que el bot sabe decir</span>
          <span className="block text-sm text-gray-500">
            Los hechos con los que el bot público contesta preguntas libres, y lo que la gente
            preguntó y aquí no estaba. Sin precios: esos salen de la tabla de planes.
          </span>
        </span>
        <span className="text-sm text-blue-700">{abierto ? 'Cerrar' : 'Editar'}</span>
      </button>

      {abierto && (
        <div className="border-t p-4 space-y-5">
          {cargando && <p className="text-sm text-gray-500">Cargando…</p>}

          {pendientes.length > 0 && (
            <div className="rounded-lg bg-amber-50 p-3">
              <div className="text-sm font-semibold text-amber-900 mb-2">
                {pendientes.length} pregunta{pendientes.length === 1 ? '' : 's'} que el bot no pudo contestar
              </div>
              <p className="text-xs text-amber-900 mb-2">
                Cada una es un hecho que falta. Escríbelo abajo como fragmento nuevo y márcala
                como atendida.
              </p>
              <ul className="space-y-1">
                {pendientes.slice(0, 20).map((p) => (
                  <li key={p.id} className="flex items-start gap-2 text-sm">
                    <span className="flex-1 text-gray-900">«{p.pregunta}»</span>
                    <button
                      type="button"
                      onClick={() => atendida(p.id)}
                      className="inline-flex items-center gap-1 text-xs text-blue-700 shrink-0"
                    >
                      <CheckCircle2 className="h-3 w-3" /> Atendida
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          )}
          {!cargando && pendientes.length === 0 && (
            <p className="text-sm text-gray-500">
              No hay preguntas sin respuesta: todo lo que preguntaron estaba en la base.
            </p>
          )}

          <div className="space-y-2">
            <div className="text-xs font-semibold text-gray-500 uppercase">Fragmentos</div>
            {fragmentos.map((f) => (
              <div key={f.clave} className="rounded-lg border p-3 text-sm">
                <div className="flex items-center justify-between gap-2">
                  <span className="font-medium text-gray-900">
                    {f.titulo}{' '}
                    <span className="text-xs text-gray-500">({f.clave}{f.activo ? '' : ' · apagado'})</span>
                  </span>
                  <button
                    type="button"
                    onClick={() => setEditando({ ...f })}
                    className="text-xs text-blue-700"
                  >
                    Editar
                  </button>
                </div>
                <p className="text-gray-700 mt-1">{f.texto}</p>
                <p className="text-xs text-gray-500 mt-1">Se encuentra con: {f.palabras || '—'}</p>
              </div>
            ))}
            <button
              type="button"
              onClick={() => setEditando({ ...NUEVO })}
              className="text-sm text-blue-700"
            >
              + Fragmento nuevo
            </button>
          </div>

          {editando && (
            <div ref={vigilar} className="rounded-lg border p-3 space-y-2 bg-gray-50">
              <label className="block text-sm font-medium text-gray-900" htmlFor="frag-clave">
                Clave
              </label>
              <p className="text-xs text-gray-500">Un nombre corto sin espacios, por ejemplo «sin_internet». No se enseña a nadie.</p>
              <input
                id="frag-clave"
                value={editando.clave}
                onChange={(e) => setEditando({ ...editando, clave: e.target.value })}
                className="w-full rounded-lg border px-3 py-2 text-sm"
              />
              <label className="block text-sm font-medium text-gray-900" htmlFor="frag-titulo">
                Título
              </label>
              <input
                id="frag-titulo"
                value={editando.titulo}
                onChange={(e) => setEditando({ ...editando, titulo: e.target.value })}
                className="w-full rounded-lg border px-3 py-2 text-sm"
              />
              <label className="block text-sm font-medium text-gray-900" htmlFor="frag-texto">
                Texto
              </label>
              <p className="text-xs text-gray-500">
                Hechos, en dos o tres frases. Sin precios ni promesas: el bot solo puede decir lo que
                está aquí, y así es como no inventa.
              </p>
              <textarea
                id="frag-texto"
                rows={4}
                value={editando.texto}
                onChange={(e) => setEditando({ ...editando, texto: e.target.value })}
                className="w-full rounded-lg border px-3 py-2 text-sm"
              />
              <label className="block text-sm font-medium text-gray-900" htmlFor="frag-palabras">
                Palabras con las que se encuentra
              </label>
              <p className="text-xs text-gray-500">Separadas por coma, como las escribiría la gente: «sin wifi, sin internet, offline».</p>
              <input
                id="frag-palabras"
                value={editando.palabras}
                onChange={(e) => setEditando({ ...editando, palabras: e.target.value })}
                className="w-full rounded-lg border px-3 py-2 text-sm"
              />
              <label className="inline-flex items-center gap-2 text-sm text-gray-900">
                <input
                  type="checkbox"
                  checked={editando.activo}
                  onChange={(e) => setEditando({ ...editando, activo: e.target.checked })}
                />
                Activo (apagado = el bot no lo usa, pero no se borra)
              </label>
              <div className="flex items-center gap-3">
                <button
                  type="button"
                  onClick={guardar}
                  disabled={!puedeGuardar}
                  className="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-gray-900 text-white text-sm font-medium disabled:opacity-50"
                >
                  <Save className="h-4 w-4" /> Guardar
                </button>
                {!puedeGuardar && (
                  <span className="text-sm text-gray-500">Clave, título y texto son obligatorios.</span>
                )}
                <button type="button" onClick={() => setEditando(null)} className="text-sm text-gray-600">
                  Cancelar
                </button>
              </div>
            </div>
          )}

          {error && <div className="rounded-lg bg-red-50 text-red-800 text-sm p-3">{error}</div>}
          {guardado && (
            <div className="rounded-lg bg-green-50 text-green-800 text-sm p-3">
              Guardado. El bot lo usa desde el siguiente mensaje.
            </div>
          )}
        </div>
      )}
    </section>
  );
}
